"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CdnAdaptor = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _checkAliveManager = require("../checkAliveManager");

var _AdaptError = require("../AdaptError");

var _excluded = ["priority", "cdnConfigs", "onError", "filter"],
    _excluded2 = ["toUrl", "checkAlive"],
    _excluded3 = ["toUrl"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CdnAdaptor = /*#__PURE__*/function (_CheckAliveManager) {
  (0, _inherits2["default"])(CdnAdaptor, _CheckAliveManager);

  var _super = _createSuper(CdnAdaptor);

  function CdnAdaptor(_ref) {
    var _this;

    var priority = _ref.priority,
        cdnConfigs = _ref.cdnConfigs,
        onError = _ref.onError,
        filter = _ref.filter,
        rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    (0, _classCallCheck2["default"])(this, CdnAdaptor);
    _this = _super.call(this);
    _this.priority = priority || Object.keys(cdnConfigs);
    _this.onError = onError;
    _this.filter = filter;
    _this.cdnConfigs = Object.entries(cdnConfigs).reduce(function (prev, _ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      prev[key] = _objectSpread(_objectSpread({
        toUrl: function toUrl(url) {
          return url;
        }
      }, rest), value);
      return prev;
    }, {});
    return _this;
  }

  (0, _createClass2["default"])(CdnAdaptor, [{
    key: "getAvailableCdnUrl",
    value: function () {
      var _getAvailableCdnUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
        var ignoreCache,
            errors,
            _iterator,
            _step,
            key,
            _this$cdnConfigs$key,
            toUrl,
            checkAlive,
            res,
            cdnUrl,
            _args = arguments;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ignoreCache = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;

                if (!(this.filter && !this.filter(url))) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", [url, null]);

              case 3:
                errors = [];
                _iterator = _createForOfIteratorHelper(this.priority);
                _context.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context.next = 20;
                  break;
                }

                key = _step.value;
                _this$cdnConfigs$key = this.cdnConfigs[key], toUrl = _this$cdnConfigs$key.toUrl, checkAlive = _this$cdnConfigs$key.checkAlive, res = (0, _objectWithoutProperties2["default"])(_this$cdnConfigs$key, _excluded2); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

                cdnUrl = toUrl(url, res);
                _context.next = 13;
                return this.getCheckAliveResult.apply(this, [cdnUrl, ignoreCache].concat((0, _toConsumableArray2["default"])(checkAlive ? checkAlive(url, res) : [])));

              case 13:
                if (!_context.sent) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", [cdnUrl, errors !== null && errors !== void 0 && errors.length ? errors : null]);

              case 17:
                errors.push(new _AdaptError.AdaptError("".concat(cdnUrl, ": check alive failed"), 3, {
                  host: res.host,
                  bucket: res.bucket,
                  key: key
                }));

              case 18:
                _context.next = 7;
                break;

              case 20:
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](5);

                _iterator.e(_context.t0);

              case 25:
                _context.prev = 25;

                _iterator.f();

                return _context.finish(25);

              case 28:
                return _context.abrupt("return", [null, [new _AdaptError.AdaptError("".concat(url, ": all cdn check alive failed"), 2, {
                  key: 'cdns',
                  host: '',
                  bucket: ''
                })]]);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 22, 25, 28]]);
      }));

      function getAvailableCdnUrl(_x) {
        return _getAvailableCdnUrl.apply(this, arguments);
      }

      return getAvailableCdnUrl;
    }()
  }, {
    key: "getAvailableUrl",
    value: function () {
      var _getAvailableUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url) {
        var _this2 = this;

        var ignoreCache,
            _yield$this$getAvaila,
            _yield$this$getAvaila2,
            cdnUrl,
            errors,
            _args2 = arguments;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ignoreCache = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
                _context2.next = 3;
                return this.getAvailableCdnUrl(url, ignoreCache);

              case 3:
                _yield$this$getAvaila = _context2.sent;
                _yield$this$getAvaila2 = (0, _slicedToArray2["default"])(_yield$this$getAvaila, 2);
                cdnUrl = _yield$this$getAvaila2[0];
                errors = _yield$this$getAvaila2[1];

                if (!cdnUrl) {
                  _context2.next = 10;
                  break;
                }

                errors === null || errors === void 0 ? void 0 : errors.map(function (error) {
                  var _this2$onError;

                  (_this2$onError = _this2.onError) === null || _this2$onError === void 0 ? void 0 : _this2$onError.call(_this2, error);
                });
                return _context2.abrupt("return", [cdnUrl, errors]);

              case 10:
                return _context2.abrupt("return", (0, _checkAliveManager.fetchCheck)(url).then(function () {
                  errors === null || errors === void 0 ? void 0 : errors.map(function (error) {
                    var _this2$onError2;

                    (_this2$onError2 = _this2.onError) === null || _this2$onError2 === void 0 ? void 0 : _this2$onError2.call(_this2, error);
                  });
                  return [url, errors];
                })["catch"](function () {
                  var _this2$onError3;

                  var error = new _AdaptError.AdaptError("".concat(url, ": all links(including source link) are not alive"), 1, {
                    key: 'all',
                    host: '',
                    bucket: ''
                  });
                  (_this2$onError3 = _this2.onError) === null || _this2$onError3 === void 0 ? void 0 : _this2$onError3.call(_this2, error);
                  return [null, [error]];
                }));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAvailableUrl(_x2) {
        return _getAvailableUrl.apply(this, arguments);
      }

      return getAvailableUrl;
    }()
  }, {
    key: "getHighestPriorityUrl",
    value: function getHighestPriorityUrl(url) {
      return this.getCdnUrl(url, this.priority[0]);
    }
  }, {
    key: "getCdnUrl",
    value: function getCdnUrl(url, key) {
      var _this$cdnConfigs$key2 = this.cdnConfigs[key],
          toUrl = _this$cdnConfigs$key2.toUrl,
          res = (0, _objectWithoutProperties2["default"])(_this$cdnConfigs$key2, _excluded3);
      if (this.filter && !this.filter(url)) return url; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      return toUrl(url, res);
    }
  }]);
  return CdnAdaptor;
}(_checkAliveManager.CheckAliveManager);

exports.CdnAdaptor = CdnAdaptor;